import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewChild
} from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { JProject } from '@ascschool/interface/project';
import { SideBarLink } from '@ascschool/interface/ui-model/nav-link';
import { ProjectQuery } from '@ascschool/project/state/project/project.query';
import { NzModalService } from 'ng-zorro-antd/modal';
import { NzDrawerService } from 'ng-zorro-antd/drawer';
import { SearchDrawerComponent } from '../../search/search-drawer/search-drawer.component';
import { SettingDrawerComponent } from '../../menu-drawer/setting-drawer/setting-drawer.component';
import { SettingSchoolComponent } from '../../menu-drawer/setting-school/setting-school.component';
import { AuthService } from '@ascschool/core/auth/auth.service';
import { JUser } from '@ascschool/interface/user';
import { TabService } from '@ascschool/project/tabs/tab.service';
import { Tab } from '@ascschool/project/tabs/tab.model';
import { addDays, formatDistance } from 'date-fns';
import { SideBarService } from '../../../../services/sidebar.service';
import { AuthStore } from '@ascschool/core/auth';
import { ThongTinNguoiDungComponent } from '@ascschool/project/pages/thong-tin-tai-khoan/thong-tin-nguoi-dung/thong-tin-nguoi-dung.component';
import { DoiMatKhauComponent } from '@ascschool/project/pages/thong-tin-tai-khoan/doi-mat-khau/doi-mat-khau.component';
@Component({
  selector: 'app-sidebar-top',
  templateUrl: './sidebar-top.component.html',
  styleUrls: ['./sidebar-top.component.scss']
})
@UntilDestroy()
export class SidebarTopComponent implements OnInit, AfterViewInit {
  @ViewChild('sideBar', { static: false }) elementsideBar: ElementRef;
  @ViewChild('logo', { static: false }) elementlogo: ElementRef;
  @ViewChild('userMenu', { static: false }) elementUserMenu: ElementRef;
  items: NavItem[];
  userItems: NavItem[];
  userInfo: JUser;
  @Input() expanded: boolean;
  width: number;
  maxWidth: number;
  @ViewChild('elItem') elItem: ElementRef<HTMLElement>;

  get sidebarWidth(): number {
    return this.expanded ? 240 : 15;
  }
  isSelectedMenu: boolean;
  project: JProject;
  sideBarLinks: SideBarLink[];

  dataBl = [
    {
      author: 'Anh Xanh',
      likes: 5,
      dislikes: 0,
      avatar: 'https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png',
      content: 'Học, học nữa học mãi',
      datetime: formatDistance(new Date(), addDays(new Date(), 1))
    },
    {
      author: 'Anh Xanh',
      likes: 5,
      dislikes: 0,
      avatar: 'https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png',
      content: 'Vững bước thành công',
      datetime: formatDistance(new Date(), addDays(new Date(), 2))
    }
  ];

  constructor(
    private _projectQuery: ProjectQuery,
    private _drawerService: NzDrawerService,
    private cdRef: ChangeDetectorRef,
    public _authService: AuthService,
    private tabService: TabService,
    private _sideBarService: SideBarService,
    private modalService: NzModalService
  ) {
    this._projectQuery.all$.pipe(untilDestroyed(this)).subscribe((project) => {
      this.project = project;
    });
  }

  ngOnInit(): void {
    this.isSelectedMenu = false;
    this.getSideBar();
    this.items = [
      new NavItem('search', 'Search issues', this.openSearchDrawler.bind(this)),
      new NavItem('plus', 'Create issue', this.openSearchDrawler.bind(this)),
      new NavItem('setting', 'Setting', this.openSettingDrawler.bind(this))
    ];
    this.userItems = [
      new NavItem('clear', 'Xóa bộ nhớ đệm', this._authService.clearCache.bind(this)),
      new NavItem('user', 'Thông tin người dùng', this.openPopupUserInfo.bind(this)),
      new NavItem('key', 'Đổi mật khẩu', this.openPopupChangePassword.bind(this)),
      new NavItem('setting', 'Cài đặt chung', this.openSettingDrawler.bind(this)),
      new NavItem('mail', 'Hộp thư', this.onOpenMail.bind(this)),
    ];
    this._authService.getNavChangeEmitter().subscribe((item) => {
      this.width = this.caculateWidth();
    });
    this.userInfo = this._authService.getUserInfo();
  }

  getSideBar() {
    this._sideBarService.getMenu().subscribe((sidebar) => {
      this.sideBarLinks = this.list_to_tree(sidebar);
    });
  }

  list_to_tree(list) {
    // tslint:disable-next-line: one-variable-per-declaration
    let map = {},
      node,
      roots = [],
      i;
    roots.push(new SideBarLink(1, 'Trang chủ', 'dashboard', 'board', 'board', []));
    for (i = 0; i < list.length; i += 1) {
      map[list[i].idTab] = i; // initialize the map
      list[i].subTabs = []; // initialize the children
    }

    for (i = 0; i < list.length; i += 1) {
      node = list[i];
      if (node.parentId !== 0) {
        // if you have dangling branches check that map[node.ptaId] exists
        list[map[node.parentId]].subTabs.push(node);
      } else {
        roots.push(node);
      }
    }
    return roots;
  }
  arrayToTree(items: any[]) {
    /**
     * The nested tree.
     * @type {*[]}
     */
    const rootItems = [];

    // (1) Create a holder for each item.

    const lookup = {};

    for (const item of items) {
      const itemId = item.id;
      const parentId = item.parentId;

      // (2) Create a placeholder for each item in the lookup.
      // Details are added later.

      if (!lookup[itemId]) { lookup[itemId] = { ['subTabs']: [] }; }

      // (3) Add the details of the item.

      lookup[itemId] = { ...item, ['subTabs']: lookup[itemId].subTabs };

      // (4) Create a variable for the current item.

      const TreeItem = lookup[itemId];

      // (5) Determine where the item goes in the tree.

      // If the item has no parentId, it is the root node.
      if (parentId === null || parentId === undefined || parentId === '0') {
        rootItems.push(TreeItem);
      } else {
        /*
         * If the item has a parentId, add it to the tree.
         */
        // (6) Add a placeholder for parent of the current item.

        if (!lookup[parentId]) { lookup[parentId] = { ['subTabs']: [] }; }

        // (7) Add the current item to its parent.

        lookup[parentId].subTabs.push(TreeItem);
      }
    }
    return rootItems;
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.width = this.caculateWidth();
    }, 1);
    this.cdRef.detectChanges();
  }
  onOpenTab(info: SideBarLink) {
    this.tabService.newTab(new Tab(info.title, info.url));
  }
  onResize() {
    this.width = this.caculateWidth();
  }
  caculateWidth() {
    this.maxWidth = window.innerWidth;
    const widthlogo = this.elementlogo.nativeElement.offsetWidth;
    const widthUserMenu = this.elementUserMenu.nativeElement.offsetWidth;
    if (
      this._authService.getSettingInfo().hiddenInfoNav === false &&
      this._authService.getSettingInfo().positionInfoNav === 'right'
    ) {
      return this.maxWidth - widthlogo - 70 - widthUserMenu;
    } else {
      return this.maxWidth - widthlogo - widthUserMenu;
    }
  }
  openSearchDrawler() {
    this._drawerService.create({
      nzContent: SearchDrawerComponent,
      nzTitle: null,
      nzPlacement: 'right',
      nzClosable: false,
      nzWidth: 500
    });
  }
  openSettingDrawler() {
    this._drawerService.create({
      nzContent: SettingDrawerComponent,
      nzTitle: 'Cài đặt chung',
      nzPlacement: 'right',
      nzClosable: false,
      nzWidth: 700
    });
  }
  openSettingSchool() {
    this._drawerService.create({
      nzContent: SettingSchoolComponent,
      nzTitle: 'Cài đặt trường',
      nzPlacement: 'right',
      nzClosable: false,
      nzWidth: 700
    });
  }
  openPopupUserInfo() {
    this._drawerService.create({
      nzTitle: '<i class="fas fa-user"></i> Thông tin người dùng',
      nzContent: ThongTinNguoiDungComponent,
      nzPlacement: 'right',
      nzClosable: false,
      nzWidth: 700
    });
  }
  openPopupChangePassword() {
    this._drawerService.create({
      nzTitle: '<i class="fas fa-key"></i> Cập nhật mật khẩu',
      nzContent: DoiMatKhauComponent,
      nzPlacement: 'right',
      nzClosable: false,
      nzWidth: 700
    });
  }
  onScroll(event: WheelEvent): void {
    (event.target as Element).scrollLeft += event.deltaY * 4;
    event.preventDefault();
  }
  logout() {
    this._authService.logout();
  }
  onOpenMail() {
    let mail = {
      icon: "user",
      id: 64,
      idTab: 64,
      level: 1,
      parentId: 0,
      subTabs: [],
      title: "Hộp thư",
      url: "/mail",
    }
  
    this.tabService.newTab(new Tab(mail.title, mail.url));
  }
}
class NavItem {
  constructor(public icon: string, public tooltip: string, public handler: Handler) {}
}
type Handler = () => void;
